import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import queryString from "query-string";

import api from "libs/api";

const UsersContext = createContext();

const UsersProvider = ({ children }) => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const { page: _page, type: _type, ...filters } = queryString.parse(search);
  const default_sort = "created_at:desc";

  const [init_loading, setInitLoading] = useState(true);

  const { isLoading: loading, data: users, isSuccess } = useQuery({
    queryKey: ["users", filters],
    queryFn: () =>
      api.get(
        `/admin/users?${queryString.stringify({
          ...filters,
          sort: filters?.sort || default_sort,
        })}`
      ),
  });

  useEffect(() => {
    if (isSuccess) {
      setInitLoading(false);
    }
  }, [isSuccess]);

  const filterHandler = (name, value) => {
    navigate(
      `/users?${queryString.stringify({
        ...filters,
        [name]: value || undefined,
      })}`
    );
  };

  const value = useMemo(() => {
    return {
      data: users,
      loading,
      init_loading,
      filters,
      filterHandler,
    };
    // eslint-disable-next-line
  }, [users, loading, init_loading, filters]);

  return (
    <UsersContext.Provider value={value}>{children}</UsersContext.Provider>
  );
};

const useUsers = () => useContext(UsersContext);
export { UsersContext, useUsers };
export default UsersProvider;
